var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item",class:{active: _vm.selected},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.formatDate(_vm.amendment.validOn))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }